angular.module('bizmetryApp').controller('AgentLogsDialogController', function (
  $scope, $mdDialog, agent, TelemetryAgentService, ConfigurationService, $mdToast
) {
  // ─── State ───────────────────────────────────────
  $scope.agent          = agent;
  $scope.logs           = [];
  $scope.loading        = false;
  $scope.noLogsFound    = false;
  $scope.selectedLog    = null;
  $scope.liveTailEnabled = false;
  $scope.refreshing     = false;

  // ─── Pagination ──────────────────────────────────
  $scope.currentPage  = 1;
  $scope.totalPages   = 1;
  $scope.logsPerPage  = ConfigurationService.getFromCache('frontend.log_page_size') || 50;

  // ─── Filters ─────────────────────────────────────
  $scope.logLevelFilter = 'ALL';
  $scope.searchText     = '';
  $scope.instanceFilter = 'ALL'; // 'ALL' = todas las instancias; o un podName puntual
  $scope.instances      = [];

  // ─── Config ──────────────────────────────────────
  $scope.logMessageLengthLimit = ConfigurationService.getFromCache('frontend.agent.logs_message_max_len');
  $scope.logModuleLengthLimit  = ConfigurationService.getFromCache('frontend.agent.logs_module_max_len');

  let liveTailInterval           = null;
  let previousPageBeforeLiveTail = null;

  // ─── Data loading ─────────────────────────────────
  function _fetchLogs(page, size) {
    return TelemetryAgentService.fetchLogs(
      agent.agentId,
      page,
      size || $scope.logsPerPage,
      $scope.searchText,
      $scope.logLevelFilter,
      $scope.instanceFilter !== 'ALL' ? $scope.instanceFilter : null
    );
  }

  TelemetryAgentService.getAgentInstances(agent.agentId, agent.accountId)
    .then(function (response) { $scope.instances = response.data || []; })
    .catch(function (error) { console.warn('AgentLogs: error loading instances', error); });

  $scope.loadLogs = function () {
    $scope.loading     = true;
    $scope.noLogsFound = false;

    _fetchLogs($scope.currentPage - 1)
      .then(function (response) {
        const data      = response.data;
        $scope.logs     = data.content || [];
        $scope.totalPages = data.totalPages || 1;
        $scope.noLogsFound = !$scope.logs.length;
      })
      .catch(function (error) {
        $scope.logs       = [];
        $scope.totalPages = 1;
        $scope.noLogsFound = error.status === 204;
        if (error.status !== 204) console.error('Failed to load logs', error);
      })
      .finally(function () { $scope.loading = false; });
  };

  $scope.fetchLogs = function () {
    $scope.currentPage = 1;
    $scope.loadLogs();
  };

  $scope.onPageSizeChange = function () {
    $scope.currentPage = 1;
    $scope.loadLogs();
  };

  // ─── Pagination ──────────────────────────────────
  $scope.nextPage = function () {
    if ($scope.liveTailEnabled || $scope.currentPage >= $scope.totalPages) return;
    $scope.currentPage++;
    $scope.loadLogs();
  };

  $scope.prevPage = function () {
    if ($scope.liveTailEnabled || $scope.currentPage <= 1) return;
    $scope.currentPage--;
    $scope.loadLogs();
  };

  // ─── Live tail ────────────────────────────────────
  function _fetchLiveLogs() {
    _fetchLogs(0)
      .then(function (response) {
        $scope.logs       = response.data?.content || [];
        $scope.totalPages = response.data?.totalPages || 1;
      })
      .catch(function (err) { console.error('Live tail error:', err); });
  }

  function _startLiveTail() {
    previousPageBeforeLiveTail = $scope.currentPage;
    $scope.currentPage         = 1;
    $scope.refreshing          = true;
    _fetchLiveLogs();
    const interval = ConfigurationService.getFromCache('frontend.log_tail_refresh_interval') || 5000;
    liveTailInterval = setInterval(_fetchLiveLogs, interval);
  }

  function _stopLiveTail() {
    $scope.refreshing = false;
    if (liveTailInterval) { clearInterval(liveTailInterval); liveTailInterval = null; }
    if (previousPageBeforeLiveTail !== null) {
      $scope.currentPage         = previousPageBeforeLiveTail;
      previousPageBeforeLiveTail = null;
      $scope.loadLogs();
    }
  }

  $scope.toggleLiveTail = function () {
    $scope.liveTailEnabled ? _startLiveTail() : _stopLiveTail();
  };

  // ─── Row selection ────────────────────────────────
  $scope.selectLog = function (log, $event) {
    $mdDialog.show({
      controller:          'LogDetailDialogController',
      templateUrl:         'profile/tabs/agents/logs/log-detail-dialog.html',
      parent:              angular.element(document.body),
      targetEvent:         $event,
      clickOutsideToClose: true,
      escapeToClose:       true,
      multiple:            true,
      locals:              { log: log }
    });
  };

  // ─── Reset ───────────────────────────────────────
  $scope.resetFilters = function () {
    if ($scope.liveTailEnabled) {
      $scope.liveTailEnabled = false;
      _stopLiveTail();
    }
    $scope.logLevelFilter = 'ALL';
    $scope.searchText     = '';
    $scope.instanceFilter = 'ALL';
    $scope.currentPage    = 1;
    $scope.logsPerPage    = ConfigurationService.getFromCache('frontend.log_page_size') || 50;

    $mdToast.show(
      $mdToast.simple()
        .textContent('Filters reset')
        .position('top right')
        .hideDelay(2000)
    );

    $scope.loadLogs();
  };

  // ─── Export ──────────────────────────────────────
  $scope.exportLogs = function () {
    const pad = n => n.toString().padStart(2, '0');
    const now = new Date();
    const ts  = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())}` +
                `T${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;
    const fileName = `${$scope.agent.agentName || 'logs'}.${ts}.logs.json`;

    _fetchLogs(0, 0)
      .then(function (response) {
        const logs = response.data?.content || [];
        if (!logs.length) { $mdToast.show($mdToast.simple().textContent('No logs to export.').position('top right').hideDelay(2500)); return; }

        logs.sort((a, b) => b.seq - a.seq);

        const formatted = logs.map(function (log) {
          const d   = new Date(log.timestamp);
          const pad = n => n.toString().padStart(2, '0');
          return {
            ...log,
            timestamp: `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ` +
                       `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${d.getMilliseconds().toString().padStart(3,'0')}`
          };
        });

        const blob = new Blob([JSON.stringify(formatted, null, 2)], { type: 'application/json' });
        const link = document.createElement('a');
        link.href     = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(function (err) {
        console.error('Export failed:', err);
        $mdToast.show($mdToast.simple().textContent('Export failed.').position('top right').hideDelay(3000));
      });
  };

  // ─── Timestamp formatter ──────────────────────────
  $scope.formatTimestamp = function (ts) {
    try {
      const d   = new Date(ts);
      const pad = n => n < 10 ? '0' + n : n;
      const ms  = d.getMilliseconds().toString().padStart(3, '0');
      return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ` +
             `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${ms}`;
    } catch { return ts; }
  };

  // ─── Dialog close ─────────────────────────────────
  $scope.close = function () { $mdDialog.cancel(); };

  // ─── Init ─────────────────────────────────────────
  $scope.loadLogs();
});